import styled, { css } from 'styled-components';
import { Player } from 'video-react';

export const Flex = styled.div<{
  gap?: number;
  justifyCenter?: boolean;
  justifyBetween?: boolean;
}>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  ${(props) =>
    props.gap
      ? css`
          gap: ${props.gap}px;
        `
      : undefined}
  ${(props) =>
    props.justifyCenter
      ? css`
          justify-content: center;
        `
      : undefined}
      ${(props) =>
    props.justifyBetween
      ? css`
          justify-content: space-between;
        `
      : undefined}
`;

export const Media = styled.div`
  color: var(--text-color);
  font-size: 16px;
  line-height: 24px; /* 150% */

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--spacing-1);
  flex: 1;

  svg {
    color: var(--blue-core);
  }
`;

export const StyledPlayer = styled(Player)`
  .video-react-poster,
  .video-react-video {
    border-radius: 12px;
  }
`;
